export function getWebGatewayHeaders(authorization: string) {
  const token = authorization.replace(/^Bearer\s+/i, "").trim();
  return {
    Authorization: authorization,
    accesstoken: token,
    platform: "web",
    "product-id": import.meta.env.VITE_PRODUCT_ID ?? "300",
    "tenant-id": import.meta.env.VITE_TENANT_ID ?? "1",
    "ot-tenant": "infinitylearn",
    "x-tenant": "infinitylearn",
    "x-platform": "web",
    "x-product": "1",
  };
}
